import React, { useEffect } from "react";
import warranty_icon from "../../assets/warranty_icon.png";
import icon_1 from "../../assets/warranty_hand_icon.png";
import icon_2 from "../../assets/warranty_list_icon.png";
const WarrantyPage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div className="bg-[#f5f6f1] font-lexend">
      <h1 className="xl:text-6xl lg:text-5xl text-4xl sm:text-3xl font-lexend pt-36 pb-10 font-extralight text-center text-[#3a683f]">
        Warranty Coverage
      </h1>

      <div className="w-full md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[88rem] 2xl:px-0 xl:px-8 md:px-0 px-6 flex justify-center items-center flex-col xs:px-4 mx-auto">
        <p className="text-center lg:text-xl md:text-lg text-base xl:px-4 font-light font-lexend text-[#3a683f] 3xl:w-4/5 2xl:w-[85%]">
          Moondew provides a 5-year limited warranty against manufacturing
          defects in materials and workmanship (excluding fabric cover, zipper
          and handles, if any). Moondew will repair or replace the mattress at
          its discretion.
        </p>
        <div className="xl:w-[1000px]  mt-16">
          <div className="grid lg:grid-cols-2 grid-cols-1 xl:gap-10 gap-5">
            <div className="w-full bg-white overflow-hidden rounded-[10px] border border-[#2a552f]">
              <div className="bg-[#2a552f] md:text-xl text-lg font-semibold font-lexend md:h-[50px] h-11 flex justify-center capitalize items-center text-white text-center">
                covered
              </div>
              <div className="xl:pt-8 pt-5 lg:pb-0 pb-5  sm:text-base xxs:text-sm text-lg text-[#3a683f] leading-[24px] font-lexend font-light">
                <ul className="list-disc ps-2 xl:w-3/5 w-4/5  mx-auto">
                  <li>Sagging or deformity over 1 inch</li>
                  <li>Structural foam defects or splits</li>
                </ul>
                <p className="xl:w-2/3 mt-1.5 w-4/5 mx-auto">
                  (Measured without load on a flat, supportive base)
                </p>
              </div>
            </div>
            <div className="w-full bg-white overflow-hidden rounded-[10px] border border-[#980b0b]">
              <div className="bg-[#980b0b] md:text-xl text-lg font-semibold font-lexend md:h-[50px] h-11 flex justify-center capitalize items-center text-white text-center">
                Not Covered
              </div>
              <div className="xl:py-8 py-5  sm:text-base xxs:text-sm text-lg text-[#3a683f] leading-[24px] font-lexend font-light">
                <ul className="list-disc ps-2 xl:w-3/5 w-4/5 mx-auto">
                  <li>Sagging 1 inch or less</li>
                  <li>Damage due to mishandling</li>
                  <li>Stains, fluid damage or tears</li>
                  <li>Improper bed base or support</li>
                  <li>Fabric cover, zipper, handles</li>
                  <li>Unauthorized repairs</li>
                  <li>Unsanitary conditions</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-white py-12 mt-5 rounded-[10px]">
            <div className="grid lg:grid-cols-2 grid-cols-1 xl:gap-20 gap-5">
              <div className="flex justify-center items-center sm:gap-6 gap-10 ">
                <img src={warranty_icon} alt="" />
                <h3 className="text-[22px] font-semibold font-lexend text-[#2a552f] leading-tight">
                  Warranty <br />
                  Conditions
                </h3>
              </div>
              <div className="">
                <div className=" sm:text-base xxs:text-sm text-lg text-[#3a683f] leading-[24px] font-lexend font-light">
                  <ul className="list-disc lg:ps-2 w-full xs:ps-10 ps-14">
                    <li>Valid only for the original purchaser</li>
                    <li>Invoice and warranty card required</li>
                    <li>Mishandling voids warranty</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="grid xl:grid-cols-2 w-full gap-10 lg:px-16 xs:px-2 px-5 sm:mt-10 mt-14">
          <div className="flex sm:flex-col flex-row gap-5">
            <img className="w-20" alt="" src={icon_1} />
            <div>
              <h4 className="text-xl text-[#3a683f] font-semibold">
                Liability
              </h4>
              <p className="sm:text-base xxs:text-sm text-lg leading-[24px] pt-1 font-light md:pe-5 text-[#3a683f]">
                Maximum liability limited to original invoice value. Replacement
                does not extend warranty period.
              </p>
            </div>
          </div>
          <div className="flex sm:flex-col flex-row gap-5">
            <img className=" w-20" alt="" src={icon_2} />
            <div>
              <h4 className="text-xl text-[#3a683f] font-semibold">
                Claim Process
              </h4>
              <p className="sm:text-base xxs:text-sm text-lg leading-[24px] pt-1 font-light  text-[#3a683f]">
                Submit invoice and warranty card. Approved claims are repaired
                or replaced.
              </p>
            </div>
          </div>
        </div>
        <div className="w-full  lg:h-32 md:h-28 h-20 xs:h-16"></div>
      </div>
    </div>
  );
};

export default WarrantyPage;
